import { DateRangeType } from '../constants';
import { RangeType } from '../enums';
import {
  ICreateOrganizationUser,
  IHealthcareApi,
  IOrderOrganizationDevicesRequest,
  IOrganization,
  IOrganizationDevice,
  IOrganizationDevices,
  IOrganizationUser,
  IOrganizationUsers,
  IPatient,
  IPhysiologicalData,
  IRegisterOrganizationDevicesRequest,
} from '../interfaces';
import { isAdmin } from '../utils';
import { BaseApi } from './base';
import { HealthcareApiUrls } from './utils';

export class HealthcareApi extends BaseApi implements IHealthcareApi {
  fetchOrganization = (): Promise<IOrganization> => {
    return this.get(HealthcareApiUrls.fetchOrganization());
  };

  fetchOrganizationDevices = (): Promise<IOrganizationDevices> => {
    return this.get(HealthcareApiUrls.fetchOrganizationDevices());
  };

  removeOrganizationDevice = (device: IOrganizationDevice): Promise<void> => {
    return this.delete(HealthcareApiUrls.removeOrganizationDevice(device));
  };

  registerOrganizationDevices = (request: IRegisterOrganizationDevicesRequest): Promise<void> => {
    return this.post(HealthcareApiUrls.fetchOrganizationDevices(), request);
  };

  orderOrganizationDevices = (request: IOrderOrganizationDevicesRequest): Promise<void> => {
    return this.post(HealthcareApiUrls.orderOrganizationDevices(), request);
  };

  fetchOrganizationUsers = (): Promise<IOrganizationUsers> => {
    return this.get(HealthcareApiUrls.fetchOrganizationUsers());
  };

  createOrganizationUser = (user: ICreateOrganizationUser): Promise<void> => {
    return this.post(HealthcareApiUrls.fetchOrganizationUsers(), { ...user, password: '' });
  };

  changeOrganizationUserRole = (user: IOrganizationUser): Promise<void> => {
    return this.post(HealthcareApiUrls.changeOrganizationUserRole(user), { admin: isAdmin(user) });
  };

  deleteOrganizationUser = (user: IOrganizationUser): Promise<void> => {
    return this.delete(HealthcareApiUrls.deleteOrganizationUser(user));
  };

  fetchPatients = async (): Promise<IPatient[]> => {
    const patients = await this.get(HealthcareApiUrls.fetchPatients());
    return Array.isArray(patients) ? patients : [];
  };

  fetchPhysiologicalData = (
    rangeType: RangeType,
    dateFrom: string,
    dateTo: string,
    patientId: number,
  ): Promise<IPhysiologicalData> => {
    return this.get(
      HealthcareApiUrls.fetchPhysiologicalData({
        startDate: dateFrom,
        endDate: dateTo,
        intervalSeconds: `${DateRangeType[rangeType].intervalSeconds}`,
        patientId: `${patientId}`,
      }),
    );
  };

  fetchCuffMeasurements = (dateFrom: string, dateTo: string, patientId: number): Promise<IPhysiologicalData> => {
    return this.get(
      HealthcareApiUrls.fetchCuffMeasurements({
        startDate: dateFrom,
        endDate: dateTo,
        patientId: `${patientId}`,
      }),
    );
  };
}
